module.exports = __webpack_public_path__ + "media/src/assets/Images/BathPNG-1b4b44e408efdd86f9fd5fdca04f71d6.png";